import React from 'react';
import { useObservable } from 'react-use-observable';

import { Card } from 'antd';

import CopyText from 'v2/components/Shared/CopyText';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import newRefundService from 'v2/services/new-refund-service';
import type { NewRefundServicePermission } from 'v2/services/new-refund-service';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import FiscalDocument from './fiscalDocument';
import InvoiceDetail from './invoiceDetails';
import RefundActions from './refundActions';

const PhysicalProduct = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [user] = useObservable<NewRefundServicePermission>(
    () => newRefundService.getPermissionToNewRefundServiceByInvoiceId(delivery.invoice_id.toString()),
    []
  );

  const hasPermissionToUseNewRefundService = user && user.success && user.data.producer_can_access;

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-3 sm:flex-row'>
        <div
          className='h-28 w-28 max-w-28 shrink-0 rounded bg-neutral-50 bg-cover bg-center bg-no-repeat'
          style={{ backgroundImage: `url(${delivery.product.image})` }}
        />

        <div>
          <h2 className='mb-4 text-base'>
            {delivery.product.title}
            {delivery.order.status && (
              <span className='text-success block text-sm font-normal uppercase'>{delivery.order.status}</span>
            )}
          </h2>

          {delivery.order.tracker_code && (
            <div className='text-sm'>
              <span className='font-semibold'>Rastreio:</span> <CopyText value={delivery.order.tracker_code} />
            </div>
          )}
          {delivery.freight_value ? (
            <div className='text-sm'>
              <span className='font-semibold'>Frete pago:</span>{' '}
              {delivery.freight_value.toLocaleString('pt-BR', { style: 'currency', currency: delivery.currency_code })}
            </div>
          ) : null}
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <Card size='small' title='Dados do remetente'>
        <div className='flex flex-col gap-1'>
          {delivery.producer.name && (
            <div className='text-sm'>
              <span className='font-semibold'>Nome:</span> {delivery.producer.name}
            </div>
          )}
          {delivery.producer.email && (
            <div className='text-sm'>
              <span className='font-semibold'>E-mail:</span> <CopyText value={delivery.producer.email} />
            </div>
          )}
          {delivery.producer.phone && (
            <div className='text-sm'>
              <span className='font-semibold'>Telefone:</span> <CopyText value={delivery.producer.phone} />
            </div>
          )}
          {delivery.producer.address && (
            <div className='text-sm'>
              <span className='font-semibold'>Endereço:</span> {delivery.producer.address}
            </div>
          )}
        </div>
      </Card>

      {!delivery.bankslip_installments && <InvoiceDetail delivery={delivery} />}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <BankSlipInstallment delivery={delivery} />
      )}

      {hasPermissionToUseNewRefundService && <RefundActions delivery={delivery} />}

      <FiscalDocument delivery={delivery} />

      <GetCcbTerm delivery={delivery} />
    </div>
  );
};

export default PhysicalProduct;
